module.exports = __webpack_public_path__ + "img/chu_thich.1461ff1a.png";